<svg xmlns="http://www.w3.org/2000/svg" width="12" height="9.1">
    <rect class="primary-fill" x="0" y="0" width="12" height="1.9" fill-rule="evenodd"/>
    <rect class="primary-fill" x="1.6" y="3.6" width="8.8" height="1.9" fill-rule="evenodd"/>
    <rect class="primary-fill" x="3.45" y="7.2" width="5.1" height="1.9" fill-rule="evenodd"/>
</svg>
